import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	searchIconLabel: {
		id: 'quick_find_dialog_aria_label',
		defaultMessage: 'Quick Find',
		description: 'Label text for search icon',
	},
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear search',
		description: 'Label text for clear search button',
	},
	inputPlaceholder: {
		id: 'input_placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text in primary search input',
	},
	inputAriaLabel: {
		id: 'input_aria_label',
		defaultMessage: 'Search, press enter to navigate to advanced search with your text query',
		description: 'Aria label for primary search input, directs users advanced search',
	},
});
